import React from 'react';
import { Link } from 'react-router-dom';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';

import defaultStyles from './forum-related-discussions.scss';

interface Props {
    styles: typeof defaultStyles;
    title: React.ReactNode;
    data?: any;
}

class ForumRelatedDiscussions extends React.PureComponent<Props> {
    render() {
        const { styles, data } = this.props;
        const hit =
            data &&
            data.result &&
            data.result.searchResponse &&
            data.result.searchResponse.hits &&
            data.result.searchResponse.hits.hits &&
            data.result.searchResponse.hits.hits.length &&
            data.result.searchResponse.hits.hits[0];

        let onClick;
        if (typeof window !== 'undefined') {
            onClick = () => {
                const { ga } = window;
                if (ga) {
                    ga('send', 'event', 'Read Forum Link', 'click', 'Read Forum from Magazine Link');
                }
            };
        }

        return hit ? (
            <div className={styles.wrapper}>
                <div className={styles.text}>
                    <div className={styles.hint}>
                        <FormattedMessage id='DISCUSSED_ALSO_IN' />
                    </div>
                    <Link to={hit.source.url} className={styles.link} onClick={onClick}>
                        {hit.source.threadTitle}
                    </Link>
                </div>
            </div>
        ) : null;
    }
}

export default Styled(defaultStyles)(ForumRelatedDiscussions);
